










































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AuditButton extends Vue {
  @Prop({ type: Boolean, default: false })
  private loading!: boolean;

  @Prop({ type: Boolean, default: false })
  private hasAuditsAtCompetence!: boolean;

  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;

  @Prop({ type: Boolean, default: true })
  private block!: boolean;

  private get message(): string {
    const confirmMessage = 'Essa operação pode demorar um pouco, deseja prosseguir?';
    const customMessage = this.hasAuditsAtCompetence
      ? 'Já existem dados para essa competência. Ao auditar novamente, esses dados serão inativados, e novos serão gerados.'
      : 'Não existem dados nesta competência.';
    return `${customMessage} ${confirmMessage}`;
  }

  private audit(): void {
    this.$emit('audit');
  }
}
